ready = ->
  return unless continueIfAllowed('service_visits', ['edit', 'new']) or continueIfAllowed('performed_service_records', ['edit', 'update'])

  controllerSelect = $("select[data-selector='controller-select']")
  spaceSelect = $("select[data-selector='space-select']")
  performedServiceSelect = $("select[data-selector='performed-service-select']")
  troubleTicketSelect = $("select[data-selector='trouble-ticket-select']")
  editMode = $("div[data-selector='service-performed-table']").data("edit-mode")

  setNewOptions = (options) ->
    $("option:not([value=''])", performedServiceSelect).remove()

    if options
      performedServiceSelect.attr("disabled", false)
      $.each options, (index, option) ->
        performedServiceSelect.append( $("<option></option>").attr("value", option[1]).text(option[0]) )
    else
      performedServiceSelect.attr("disabled", true)

  updateMessages = ->
    messages = $('div[data-selector="service-performed-table"]').data('performed-services')
    return unless messages

    if spaceSelect.attr("disabled") != "disabled" && spaceSelect.val() != ""
      setNewOptions(messages.space)
    else if controllerSelect.val() != ""
      setNewOptions(messages.controller)
    else
      setNewOptions(messages.location)

  updateLatches = ->
    options = $('*[data-selector="service-performed-table"]').data('ui-nodes-with-latches')
    currentId = parseInt(controllerSelect.val())
    spaceSelect.empty()
    spaceSelect.append("<option value>Select space</option>")

    $.each options, (key, option) ->
      if option.id == currentId
        $.each option.latches, (index, latch) ->
          spaceSelect.append( $("<option></option>").attr("value", latch.id).text(latch.name) )

  controllerSelect.on 'change', (e) ->
    if controllerSelect.val() == ""
      spaceSelect.attr("disabled", "disabled")
      spaceSelect.val("")
    else
      updateLatches()
      spaceSelect.attr("disabled", false)

    updateMessages()

  spaceSelect.on 'change', (e) ->
    updateMessages()


  if editMode != true
    updateMessages()
    spaceSelect.attr("disabled", "disabled")

$(document).ready(ready)
$(document).on('turbo:load', ready)
